import React, { Component } from 'react';
import Crash from '../../Assets/Image/maintenance.gif';
import { PrimaryButton } from '../Buttons';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        console.error("Error caught in boundary:", error);
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Error details:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-vh-100 d-flex flex-column justify-content-center align-items-center">
                    <div className="text-center pb-4">
                        <img
                            src={Crash}
                            alt="Crash"
                            className="object-fit-contain"
                            width={300}
                            height={300}
                        />
                        <h2 className="mb-3 e-font-32 e-alt-font  e-font-weight-500 line-height-44px">Oops! Something went wrong.</h2>
                        <p className="e-font-20 pb-4 mb-2 e-alt-font e-font-weight-400 line-height-32px">
                            We're sorry, but something went wrong while loading the page.
                        </p>
                        <div className="text-center d-flex justify-content-center">
                            <PrimaryButton
                                name="Refresh Page"
                                paddingBlock="padding-64px-lr py-3"
                                onClick={() => {
                                    window.history.back();
                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 100);
                                }}
                            />
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
